import React, { Fragment } from 'react';
import MonthwiseSalesView from './MonthwiseSalesView';

// Thin route entry — the V3 shell lives inside the view.
const MonthwiseSalesReport = () => (
    <Fragment>
        <MonthwiseSalesView />
    </Fragment>
);

export default MonthwiseSalesReport;
